import ClaimIndex from "@/components/claim/index.vue";
import routesDashboard from "@/components/claim/dashboard/routes";
import routesPengajuan from "@/components/claim/pengajuan/routes";
import routesPenerimaan from "@/components/claim/penerimaan/routes";
import routesEmailNotification from "@/components/claim/emailnotification/routes";

export default [
  {
    path: "/claim/dashboard-claim",
    component: ClaimIndex,
    children: routesDashboard
  },
  {
    path: "/claim/pengajuan",
    component: ClaimIndex,
    children: routesPengajuan
  },
  {
    path: "/claim/penerimaan",
    component: ClaimIndex,
    children:  routesPenerimaan
  },
  {
    path: "/claim/emailnotification",
    component: ClaimIndex,
    children:  routesEmailNotification
  }
];
